export enum DoorstepCollectionError {
  ADDRESS = 'Address',
  TIME = 'Time',
}
